/**
 * 유휴 렌더 게이트 — 시각 변화 신호가 없으면 렌더(포스트FX 전체 파이프라인)를 건너뛴다.
 * 유휴 화면(시작 질문/결과 카드)에서 정적 프레임을 60fps로 계속 그려 GPU가 공회전하던
 * 발열 문제의 회피책. 캔버스는 마지막 프레임을 유지하므로 렌더를 멈춰도 화면은 그대로다.
 * 활동 판정(무엇이 "시각 변화"인지)은 호출자(main.ts 배선)가 소유한다 — 이 클래스는
 * 순수 시간 로직만 담당해 node 환경에서 유닛테스트 가능하다.
 */

/** 활동이 멈춘 뒤 이 시간(초, 실시간)만큼은 렌더를 유지한다 — 잔여 연출(셰이크 복귀 등) 흡수. */
export const IDLE_RENDER_SETTLE_SEC = 0.5;

export class IdleGate {
  /** 마지막 활동(또는 wake) 시각. null이면 아직 기준점이 없다(첫 호출이 기준점). */
  private lastActiveAt: number | null = null;
  /** 직전 shouldRender 판정이 "렌더 생략"이었는지(디버그 노출용). */
  gated = false;

  constructor(private settleSec: number = IDLE_RENDER_SETTLE_SEC) {}

  /** 외부 이벤트(리사이즈·탭 복귀 등)로 강제 웨이크 — settle 창만큼 렌더가 재개된다. */
  wake(now: number): void {
    this.lastActiveAt = now;
  }

  /**
   * 매 프레임 호출. @param active 시각 변화 신호 존재 여부, @param now 실시간(초).
   * @returns true면 이번 프레임을 렌더한다.
   */
  shouldRender(active: boolean, now: number): boolean {
    if (active || this.lastActiveAt === null) this.lastActiveAt = now;
    const render = now - this.lastActiveAt < this.settleSec;
    this.gated = !render;
    return render;
  }
}
